import React from 'react';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';

const Spotlight = (props) => {


    // console.log(props);

    return (
        <div className="py-2">
            <Container className="spotlight-background" fluid>
                <Container>
                    <div className="textposition">
                        <div className="py-4 mb-5">
                            <h2 className="text-white">{props.val.spotlight_textOne}</h2>
                            <p className="text-white">{props.val.spotlight_textTwo}</p>
                            <div className="mt-5">
                                <Link to="/reservation">
                                    <Button className="button-color px-3 py-1">Book Now</Button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </Container>
            </Container>
        </div>

    );
}

export default Spotlight